import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import QRCode from "qrcode";
export default {
  name: "Login",
  data() {
    return {
      width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
      loginWord: "登录",
      loginIndex: 1,
      loginTypeFlag: false,
      phoneNumber: "",
      phoneYanzhengma: "",
      yzmFlag: true,
      countTimer: null,
      countNum: "获取验证码",
      loginFlag: true,
      isPhoneLogin: false
    };
  },
  components: {},
  mounted() {
    let _this = this;
    window.onresize = () => {
      return (() => {
        _this.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        _this.height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      })();
    };
  },
  async created() {
    console.log("login created...");
    if (localStorage.getItem("edujia:group:web:token")) {
      this.$store.commit("modifyToken", localStorage.getItem("edujia:group:web:token"));
      this.$router.push({
        name: "whome"
      });
    } else {
      await this.getMtCode();
    }
  },
  methods: {
    changeLoginMode(mode) {
      this.isPhoneLogin = mode;
    },
    clearLocalStong() {
      window.localStorage.clear();
    },
    setLocalStong(wsid, nickname, faceIcon, token, key, isVip) {
      localStorage.setItem("edujia:group:web:userid", wsid);
      localStorage.setItem("edujia:group:web:userName", nickname);
      localStorage.setItem("edujia:group:web:faceIcon", faceIcon);
      localStorage.setItem("edujia:group:web:token", token);
      localStorage.setItem("edujia:group:web:key", key);
      localStorage.setItem("edujia:group:web:isVip", isVip);
      localStorage.setItem("edujia:group:web:kv", this.$common.encrypt(isVip, this.$store.state.lk));
    },
    async getTwoCode(text) {
      try {
        return await QRCode.toDataURL(text, {
          errorCorrectionLevel: "H",
          type: "image/png",
          quality: 0.3,
          margin: 2,
          width: 151,
          color: {
            dark: "#000000ff",
            light: "#ffffffff"
          }
        });
      } catch (err) {
        console.error(err);
      }
    },
    async goHome() {
      if (this.loginFlag) {
        let myreg = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (this.phoneNumber === "") {
          this.$toast("手机号码不能为空", "", "取消", "删除", false);
        } else {
          if (myreg.test(this.phoneNumber)) {
            if (this.phoneYanzhengma === "") {
              this.$toast("验证码不能为空", "", "取消", "删除", false);
            } else {
              this.clearLocalStong();
              this.loginWord = "请稍后...";
              this.loginFlag = false;
              let params = {
                phone: Number(this.phoneNumber),
                vcode: Number(this.phoneYanzhengma)
              };
              let login = await this.$http.getLoginCode(params);
              //console.log(telLogin)
              if (login.code === 200) {
                let reallg = JSON.parse(this.$common.decrypt(login.data, this.$config.ak));
                reallg.object.token = this.$common.decrypt(reallg.object.token, reallg.object.key);
                sessionStorage.setItem("navIndex", 2);
                this.$store.commit("updateState", reallg.object);
                //await sessionStorage.setItem("store",JSON.stringify(this.$store.state))
                this.$store.commit("modifyToken", reallg.object.token);
                this.setLocalStong(reallg.object.wsid, reallg.object.nickname, reallg.object.faceIcon, reallg.object.token, reallg.object.key, reallg.object.kiVipExpireTime);
                this.$router.push({
                  name: "whome"
                });
              } else {
                this.loginWord = "登录";
                // this.$toast(login.message,'','取消','删除',false)
              }
            }
            this.loginFlag = true;
          } else {
            this.$toast("手机号码错误，请重新填写", "", "取消", "删除", false);
          }
        }
      }
    },
    async sendPhoneCode() {
      if (this.yzmFlag) {
        let myreg = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (this.phoneNumber === "") {
          this.$toast("手机号码不能为空", "", "取消", "删除", false);
        } else {
          if (myreg.test(this.phoneNumber)) {
            let data = {
              phone: this.phoneNumber.trim(),
              time: new Date().getTime()
            };
            let params = {
              phone: this.$common.encrypt(data, this.$config.ak)
            };
            console.log("params ==", params);
            let pc = await this.$http.sendMegCode(params);
            console.log(pc);
            if (pc.code === 200) {
              this.yzmFlag = false;
              this.countNum = 59;
              this.downCut();
            } else {
              // this.$toast(pc.message,'','取消','删除',false)
            }
          } else {
            this.$toast("手机号码错误，请重新填写", "", "取消", "删除", false);
          }
        }
      }
    },
    async getMtCode() {
      // let dataTo={
      //     token:this.$common.encrypt({time:new Date().getTime()},this.$config.ak)
      // }
      let dataTo = {
        token: this.$common.encrypt({
          time: new Date().getTime()
        }, this.$config.ak)
      };
      let qr = await this.$http.createQrCode(dataTo);
      let qrral = JSON.parse(this.$common.decrypt(qr.data, this.$config.ak));
      let obj = {
        app: "groupWeb",
        operation: "webLogin",
        code: qrral.object.clientId
      };
      let codeUrl = await this.getTwoCode(JSON.stringify(obj));
      document.getElementById("qrcode").src = codeUrl;
      let content = await this.$common.connectMqtt(qrral);
      await this.getLoginCode(content);
    },
    async getLoginCode(str) {
      console.log("getLoginCode:str", str);
      var params = {
        encryptData: this.$common.encrypt(str, this.$config.ak)
      };
      let ral = await this.$http.loginByCode(params);
      let ewral = JSON.parse(this.$common.decrypt(ral.data, this.$config.ak));
      ewral.object.token = this.$common.decrypt(ewral.object.token, ewral.object.key);
      sessionStorage.setItem("navIndex", 2);
      //await this.$store.commit("updateState",ewral.object)
      //await sessionStorage.setItem("store",JSON.stringify(this.$store.state))
      await this.setLocalStong(ewral.object.wsid, ewral.object.nickname, ewral.object.faceIcon, ewral.object.token, ewral.object.key, ewral.object.kiVipExpireTime);
      this.$router.push({
        name: "whome"
      });
    },
    downCut() {
      let _this = this;
      clearInterval(_this.countTimer);
      this.countTimer = setInterval(function () {
        _this.countNum--;
        if (_this.countNum < 0) {
          _this.countNum = 0;
          _this.yzmFlag = true;
          _this.countNum = "获取验证码";
          clearInterval(_this.countTimer);
        }
      }, 1000);
    }
  }
};